export default __webpack_public_path__ + "static/media/radish.143cf46d.png";